import axios from 'axios';

interface ErrorResponse {
    status: string;
    message: string;
    title: string;
}

const NoResponse = (err: any): ErrorResponse => {
    return {
        status: 'false',
        message: 'Hmm... Ocorreu um problema',
        title: 'Ops...',
    };
};

const Backend = {
    // baseURL: 'http://localhost:8091/wp-content/reactpress/apps/rental/api',
    baseURL: 'https://posto011.com.br/wp-content/reactpress/apps/rental/api',
    async call<T>(route: string, data?: any): Promise<T> {
        let contents: any = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const fetchRoute = this.baseURL + this.fixRoute(route);
        if (typeof data !== 'undefined' && data !== null && data !== false) {
            contents['body'] = JSON.stringify(data);
            return axios
                .post(fetchRoute, data, contents)
                .then((response) => {
                    if (response.status !== 200) {
                        return response;
                    }
                    return response.data;
                })
                .catch((error) => {
                    return NoResponse(error);
                });
        }
        return axios
            .get(fetchRoute, contents)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return NoResponse(error);
            });
    },
    fixRoute(route: string): string {
        if (route.slice(-1) !== '/') {
            return route;
        }
        return route;
    },
};

export default Backend;
